import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function tashiReducer(state = initialState.tashi, action) {
    let newState = state;

    switch (action.type) {
    case types.CLEAR_VERSION_ERROR:
        if (action.status === 'success'){
            newState = clearVersionError(state, action.data);
        }
        if (action.status === 'failure'){
            newState = Object.assign({}, state, {
                error: action.data
            });
        }
        return newState;

    case types.LOAD_VERSION:
        if (action.status === 'success'){
            newState = Object.assign({}, state, {
                version: action.data
            });
        }
        if (action.status === 'failure'){
            newState = Object.assign({}, state, {
                error: action.data
            });
        }
        return newState;

    default:
            return state;
    }
}

function clearVersionError (state) {
        // TODO
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}


/** WEBPACK FOOTER **
 ** ./src/app/reducers/tashiReducer.js
 **/